import { html } from "lit-element";

export const shape_circle = html`
<svg width="30" height="30">
    <circle cx="15" cy="15" r="14" stroke-width="1" fill="transparent"></circle>
</svg>
`;

export const shape_ellipse = html`
<svg width="30" height="30">
    <ellipse cx="15" cy="15" rx="14" ry="8" stroke-width="1" fill="transparent" transform="rotate(-35 15 15)"></ellipse>
</svg>
`;

export const shape_rectangle = html`
<svg width="30" height="30">
    <rect width="30" height="18" x="0" y="6" style="fill:transparent;stroke-width:2;"></rect>
</svg>
`;

export const shape_square = html`
<svg width="30" height="30">
    <rect width="30" height="30" style="fill:transparent;stroke-width:2;"></rect>
</svg>
`;

export const shape_triangle = html`
<svg height="30" width="30">
    <polygon points="0,30 15,0 30,30" style="fill:transparent;stroke-width:1"></polygon>
</svg>
`;

export const shape_tiolet = html`
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="30px" height="30px" viewBox="0 0 252.535 252.535" style="enable-background:new 0 0 252.535 252.535;" xml:space="preserve">
    <g>
        <path d="M223.314,0h-57.187c-4.284,0-7.761,3.479-7.761,7.761c0,4.282,3.477,7.761,7.761,7.761h3.192c-0.527,1.349-0.84,2.805-0.84,4.345v82.458c0,6.686-5.428,12.109-12.106,12.109H32.468c-6.686,0-12.244,5.489-10.762,12.011c4.072,17.894,16.559,30.481,25.611,37.538c5.271,4.098,10.055,12.125,10.055,18.812v49.868c0,1.549,0.315,3.006,0.84,4.35H38.288c-4.277,0-7.756,3.486-7.756,7.766c0,4.28,3.479,7.757,7.756,7.757H188.11c4.284,0,7.757-3.472,7.757-7.757c0-4.284-3.473-7.766-7.757-7.766h-14.893c0.522-1.344,0.845-2.801,0.845-4.35v-54.287c0-6.684,5.283-13.479,11.383-16.214c9.834-4.415,23.821-12.909,32.768-27.881c3.426-5.748,5.102-16.382,5.102-23.072V19.872c0-1.54-0.317-2.996-0.841-4.345h0.841c4.284,0,7.757-3.479,7.757-7.762C231.071,3.479,227.599,0,223.314,0z"></path>
    </g>
</svg>
`;

export const shape_fence = html`
<svg version="1.1" width="30px" height="30px" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px" viewBox="0 0 17.938 17.938" style="enable-background:new 0 0 17.938 17.938;" xml:space="preserve">
    <g>
        <path style="fill:#010002;" d="M17.938,5.616V4.19h-1.271V2.096l-1.121-1.283l-1.121,1.283V4.19h-1.046V2.096l-1.121-1.283l-1.121,1.283V4.19H10.09V2.096L8.969,0.813l-1.12,1.283V4.19H6.802V2.096L5.681,0.813L4.56,2.096V4.19H3.513V2.096l-1.12-1.283L1.271,2.096V4.19H0v1.426h1.271v8.273H0v1.43h1.271v1.805h2.242v-1.805H4.56v1.805h2.241v-1.805h1.047v1.805h2.24v-1.805h1.048v1.805h2.241v-1.805h1.046v1.805h2.241v-1.805h1.271v-1.43h-1.271V5.616H17.938z M4.561,13.889H3.514V5.616h1.047V13.889zM7.848,13.889H6.802V5.616h1.046V13.889z M11.137,13.889H10.09V5.616h1.047V13.889z M14.425,13.889h-1.046V5.616h1.046C14.425,5.616,14.425,13.889,14.425,13.889z"></path>
    </g>
</svg>
`;
